export const ADLE_WORDMARK_PATH =
  "M97.6562 200.75C81.5104 200.75 67.7083 206.479 56.25 217.938C44.7917 229.396 39.0625 243.198 39.0625 259.344C39.0625 275.49 44.7917 289.292 56.25 300.75C67.7083 312.208 81.5104 317.938 97.6562 317.938C113.802 317.938 127.604 312.208 139.062 300.75C150.521 289.292 156.25 275.49 156.25 259.344C156.25 243.198 150.521 229.396 139.062 217.938C127.604 206.479 113.802 200.75 97.6562 200.75ZM156.25 337.664C139.453 350.555 119.922 357 97.6562 357C70.7031 357 47.6562 347.495 28.5156 328.484C9.50521 309.344 0 286.297 0 259.344C0 232.391 9.50521 209.409 28.5156 190.398C47.6562 171.258 70.7031 161.688 97.6562 161.688C124.609 161.688 147.591 171.258 166.602 190.398C185.742 209.409 195.312 232.391 195.312 259.344V357H156.25V337.664ZM312.5 200.75C296.354 200.75 282.552 206.479 271.094 217.938C259.635 229.396 253.906 243.198 253.906 259.344C253.906 275.49 259.635 289.292 271.094 300.75C282.552 312.208 296.354 317.938 312.5 317.938C328.646 317.938 342.448 312.208 353.906 300.75C365.365 289.292 371.094 275.49 371.094 259.344C371.094 243.198 365.365 229.396 353.906 217.938C342.448 206.479 328.646 200.75 312.5 200.75ZM410.156 259.344C410.156 286.297 400.586 309.344 381.445 328.484C362.435 347.495 339.453 357 312.5 357C285.547 357 262.5 347.495 243.359 328.484C224.349 309.344 214.844 286.297 214.844 259.344C214.844 232.391 224.349 209.409 243.359 190.398C262.5 171.258 285.547 161.688 312.5 161.688C334.766 161.688 354.297 168.133 371.094 181.023V83.5625H410.156V259.344ZM468.75 357H429.688V83.5625H468.75V357ZM641.406 239.812C638.542 231.74 633.854 224.448 627.344 217.938C615.885 206.479 602.083 200.75 585.938 200.75C569.792 200.75 555.99 206.479 544.531 217.938C538.021 224.448 533.333 231.74 530.469 239.812H641.406ZM629.492 298.406H675.781C670.964 309.344 664.062 319.305 655.078 328.289C635.938 347.43 612.891 357 585.938 357C558.984 357 535.938 347.495 516.797 328.484C497.786 309.344 488.281 286.297 488.281 259.344C488.281 232.391 497.786 209.409 516.797 190.398C535.938 171.258 558.984 161.688 585.938 161.688C612.891 161.688 635.872 171.258 654.883 190.398C674.023 209.409 683.594 232.391 683.594 259.344C683.594 266.115 683.008 272.625 681.836 278.875H530.469C533.333 286.948 538.021 294.24 544.531 300.75C555.99 312.208 569.792 317.938 585.938 317.938C602.083 317.938 615.885 312.208 627.344 300.75C628.125 299.969 628.841 299.188 629.492 298.406Z";

export const AdleLogoLoader = ({ width = "100px" }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "transparent",
      }}
    >
      <style>
        {`
          /* Definimos el degradado de barrido */
          @keyframes shimmerReveal {
            0% {
              stop-offset: -100%;
            }
            100% {
              stop-offset: 200%;
            }
          }

          /* Animación sutil de respiración para todo el conjunto */
          @keyframes softBreathing {
            0%, 100% { transform: scale(1); opacity: 0.9; }
            50% { transform: scale(1.02); opacity: 1; }
          }

          .adle-shimmer-container {
            animation: softBreathing 3s infinite ease-in-out;
          }
        `}
      </style>

      <div className="adle-shimmer-container" style={{ width }}>
        <svg viewBox="0 0 704 460" xmlns="http://www.w3.org/2000/svg">
          <defs>
            {/* 1. Define the sweeping linear gradient */}
            <linearGradient
              id="shimmerGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              {/* Base grey very soft (almost invisible) */}
              <stop offset="0%" stopColor="rgba(0,0,0,0.1)" stopOpacity="1">
                <animate
                  attributeName="offset"
                  values="-1; 2"
                  dur="2s"
                  repeatCount="indefinite"
                />
              </stop>

              {/* Central brightness (your corporate color) */}
              <stop offset="50%" stopColor="#161D2A" stopOpacity="1">
                <animate
                  attributeName="offset"
                  values="-0.5; 2.5"
                  dur="2s"
                  repeatCount="indefinite"
                />
              </stop>

              {/* Back to soft grey */}
              <stop offset="100%" stopColor="rgba(0,0,0,0.1)" stopOpacity="1">
                <animate
                  attributeName="offset"
                  values="0; 3"
                  dur="2s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>
          </defs>

          {/* 2. Apply the gradient as FILL (fill) of the path */}
          <path
            d={ADLE_WORDMARK_PATH}
            fill="url(#shimmerGradient)" // Reference to the gradient defined above
          />
        </svg>
      </div>
    </div>
  );
};
